<div class="widget-mobile">
  <div class="container">
    <div class="d-flex page-padding">
      <div class="left-container">
        <div class="d-none d-lg-block back-button" (click)="goBack()">
          <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
        </div>
      </div>
      <!-- Image -->
      <div class="loyalty-details-image border rounded-4 overflow-hidden p-0">
        <img
          [ngClass]="{
            'image-opacity': currentCampaign?.campaignRedemptions_Quantity == 0
          }"
          alt=""
          [src]="currentCampaign?.image_URL"
          class="logo rounded-4"
        />
      </div>
      <div class="icon-placement">
        <ng-container *ngIf="currentCampaign?.campaignRedemptions_Quantity == 0">
          <span class="icon material-icons text-grey text-end fw-bold ms-3"> lock </span>
        </ng-container>
        <ng-container *ngIf="currentCampaign?.campaignRedemptions_Quantity > 0">
          <span class="icon material-icons text-success text-end fw-bold ms-3"> check_circle </span>
        </ng-container>
      </div>
    </div>
    <!-- Name -->
    <div class="text-center font-size-14 fw-bold mt-3">{{ currentCampaign?.CampaignName }}</div>
    <!-- Expiry -->
    <ng-container *ngIf="!isUsedCampaign">
      <div class="font-size-12 text-danger text-center pt-lg-2 pt-0">
        {{ 'offer.expiry' | translate }} {{ currentCampaign.Campaign_ExpiryDate | UtcToLocaltimePipe : dateOption.NgbDateFormat }}
      </div>
    </ng-container>
    <ng-container *ngIf="currentCampaign?.campaignRedemptions_Quantity > 0">
      <div class="available-offer-scan bg-white mt-3 rounded-4 d-flex align-items-center justify-content-center mb-4 mb-lg-2">
        <span class="font-size-12">{{ 'offer.scan.member.barcode' | translate }}</span>
      </div>
    </ng-container>
    <!-- Description -->
    <ng-container *ngIf="currentCampaign?.campaignRedemptions_Quantity == 0">
      <hr class="border-top border-disabled my-3" />
    </ng-container>
    <label class="accordion-label pt-2">{{ 'offer.description' | translate }}</label>
    <div class="font-size-14">{{ currentCampaign?.PortalDescription }}</div>
    <!-- T&Cs -->
    <ng-container *ngIf="currentCampaign?.portalDisplayTermsAndConditions">
      <hr class="border-top border-disabled my-3" />
      <label class="accordion-label pt-2">{{ 'offer.terms' | translate }}</label>
      <div class="font-size-14">{{ currentCampaign?.portalDisplayTermsAndConditions }}</div>
    </ng-container>
  </div>
</div>
